"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildProxyTransactionRequest = void 0;
const tslib_1 = require("tslib");
const web3_utils_1 = tslib_1.__importDefault(require("web3-utils"));
const constants_1 = require("../constants");
const types_1 = require("../types");
const utils_1 = require("./utils");
const ethers_1 = require("ethers");
const utils_2 = require("ethers/lib/utils");
const relayPrefix = "rlx:";
const zeroPad = "0000000000000000000000000000000000000000000000000000000000000000";
function padTo64(_hex) {
    let hex = _hex;
    if (hex.length < 64) {
        hex = (zeroPad + hex).slice(-64);
    }
    return hex;
}
function removeHexPrefix(hex) {
    return hex.replace(/^0x/, "");
}
function toUint256NoPrefix(hexString) {
    return padTo64(removeHexPrefix(hexString));
}
function bytesToHexNoPrefix(bytes) {
    let hex = removeHexPrefix(web3_utils_1.default.toHex(bytes));
    if (hex.length % 2 !== 0) {
        hex = "0" + hex;
    }
    return hex;
}
function createStructHash(from, to, data, txFee, gasPrice, gasLimit, nonce, relayHubAddress, relayAddress) {
    const txhstr = bytesToHexNoPrefix(data);
    const dataToHash = Buffer.from(relayPrefix).toString("hex") +
        removeHexPrefix(from) +
        removeHexPrefix(to) +
        txhstr +
        toUint256NoPrefix(ethers_1.BigNumber.from(txFee).toHexString()) +
        toUint256NoPrefix(ethers_1.BigNumber.from(gasPrice).toHexString()) +
        toUint256NoPrefix(ethers_1.BigNumber.from(gasLimit).toHexString()) +
        toUint256NoPrefix(ethers_1.BigNumber.from(nonce).toHexString()) +
        removeHexPrefix(relayHubAddress) +
        removeHexPrefix(relayAddress);
    return utils_2.keccak256("0x" + dataToHash);
}
function createProxySignature(signer, structHash) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        return signer.signMessage(utils_2.arrayify(structHash));
    });
}
function buildProxyTransactionRequest(signer, provider, args) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const to = constants_1.PROXY_WALLET_FACTORY_ADDRESS;
        const proxy = utils_1.deriveProxyWallet(args.from);
        const relayerFee = "0";
        const relayHub = constants_1.RELAY_HUB_ADDRESS;
        const gasLimit = yield provider.estimateGas({
            from: args.from,
            to: to,
            data: args.data,
        });
        const gasLimitStr = gasLimit.toString();
        const sigParams = {
            gasPrice: args.gasPrice,
            gasLimit: gasLimitStr,
            relayerFee: relayerFee,
            relayHub: constants_1.RELAY_HUB_ADDRESS,
            relay: args.relay,
        };
        const txHash = createStructHash(args.from, to, args.data, relayerFee, args.gasPrice, gasLimitStr, args.nonce, relayHub, args.relay);
        const sig = yield createProxySignature(signer, txHash);
        const req = {
            from: args.from,
            to: to,
            proxyWallet: proxy,
            data: args.data,
            nonce: args.nonce,
            signature: sig,
            signatureParams: sigParams,
            type: types_1.TransactionType.PROXY,
        };
        console.log(`Created Proxy Transaction Request:`);
        console.log(req);
        return req;
    });
}
exports.buildProxyTransactionRequest = buildProxyTransactionRequest;
